import{useRef as r}from"react";function n(n){const t=r(null);return null===t.current&&(t.current=n()),t.current}export{n as useConstant};
